export const PROCESSING_EVENT = 'sysmadd:processing';

export interface ProcessingEventDetail {
  active: boolean;
  count: number;
  message: string;
}

let activeRequests = 0;
let currentMessage = 'Processando...';

export function describeApiOperation(method?: string, url?: string) {
  const verb = String(method || 'get').toLowerCase();
  const path = String(url || '').toLowerCase();
  if (path.includes('/auth/')) return verb === 'post' ? 'Validando acesso...' : 'Verificando sessão...';
  if (path.includes('procedure-operations/quote')) return 'Calculando procedimento...';
  if (path.includes('procedure-config')) return verb === 'get' ? 'Carregando índices e regras...' : 'Salvando índices e regras...';
  if (path.includes('procedure-operations')) return verb === 'get' ? 'Carregando procedimentos...' : 'Salvando procedimento...';
  if (path.includes('/patients')) return verb === 'get' ? 'Buscando pacientes...' : 'Salvando paciente...';
  if (path.includes('/payments')) return verb === 'get' ? 'Carregando pagamentos...' : 'Atualizando pagamento...';
  if (path.includes('/honorary-receipts')) return path.includes('/send') ? 'Enviando recibo...' : path.includes('/pdf') ? 'Gerando PDF...' : 'Carregando recibos...';
  if (path.includes('/honoraries')) return verb === 'get' ? 'Carregando honorários...' : 'Atualizando honorários...';
  if (path.includes('/reports')) return 'Gerando relatório...';
  if (path.includes('/users')) return verb === 'get' ? 'Carregando usuários...' : 'Salvando usuário...';
  if (path.includes('/domain/')) return verb === 'get' ? 'Carregando cadastros...' : 'Salvando cadastro...';
  if (verb === 'get') return 'Carregando dados...';
  if (verb === 'delete') return 'Removendo registro...';
  return 'Salvando alterações...';
}

function emit() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<ProcessingEventDetail>(PROCESSING_EVENT, {
    detail: {
      active: activeRequests > 0,
      count: activeRequests,
      message: currentMessage,
    },
  }));
}

export function beginProcessing(message: string) {
  activeRequests += 1;
  currentMessage = message || 'Processando...';
  emit();
}

export function endProcessing() {
  activeRequests = Math.max(0, activeRequests - 1);
  if (activeRequests === 0) currentMessage = 'Processando...';
  emit();
}
